var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menubuilder__tselector" }, [
    _c("h3", [_vm._v("Coffee")]),
    _vm._v(" "),
    _c("p", { staticClass: "menubuilder__info" }, [
      _vm._v("Add your pricing into the relevant boxes"),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      [
        _c("li", [
          _c("span", {
            staticClass:
              "menubuilder__ttitle t-center hidden-mobile menubuilder__ttitle--coffee",
          }),
          _vm._v(" "),
          _vm.hideOneSize.value !== true
            ? _c(
                "span",
                {
                  staticClass: "menubuilder__tprice t-center h5",
                  attrs: { type: "text" },
                },
                [_vm._v("One Size")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "menubuilder__tprice t-center h5",
              attrs: { type: "text" },
            },
            [_vm._v("S")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "menubuilder__tprice t-center h5",
              attrs: { type: "text" },
            },
            [_vm._v("M")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "menubuilder__tprice t-center h5",
              attrs: { type: "text" },
            },
            [_vm._v("L")]
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.coffees, function (coffee, index) {
          return _c("li", { key: index }, [
            _c("div", {
              staticClass: "menubuilder__ttitle menubuilder__ttitle--coffee",
              domProps: { innerHTML: _vm._s(coffee.name) },
            }),
            _vm._v(" "),
            _vm.hideOneSize.value !== true
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: coffee.oneSize,
                      expression: "coffee.oneSize",
                    },
                  ],
                  staticClass: "menubuilder__tprice",
                  attrs: { type: "text" },
                  domProps: { value: coffee.oneSize },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(coffee, "oneSize", $event.target.value)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: coffee.s,
                  expression: "coffee.s",
                },
              ],
              staticClass: "menubuilder__tprice",
              attrs: { type: "text" },
              domProps: { value: coffee.s },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(coffee, "s", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: coffee.m,
                  expression: "coffee.m",
                },
              ],
              staticClass: "menubuilder__tprice",
              attrs: { type: "text" },
              domProps: { value: coffee.m },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(coffee, "m", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: coffee.l,
                  expression: "coffee.l",
                },
              ],
              staticClass: "menubuilder__tprice",
              attrs: { type: "text" },
              domProps: { value: coffee.l },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(coffee, "l", $event.target.value)
                },
              },
            }),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    false
      ? _c(
          "div",
          { staticClass: "menubuilder__add", on: { click: _vm.addNewCoffee } },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("span", [_vm._v("Add a coffee (max 12)")]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "plus" }, [_c("span", [_vm._v("+")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/MenuBuilder/CustomCoffeeSelector.vue